import { HTTP_CP_MortgageDeal } from '@api-new/mortgageservice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Mortgage_Deals } from '@platform/property/models/better-deal-card.model';
import { BetterDealsState } from '@shared/store/better-deal/better-deal.state';

export const selectBetterDealState = createFeatureSelector<BetterDealsState>('betterDeals');

export const selectBetterDealList = createSelector(
  selectBetterDealState,
  (state: BetterDealsState): HTTP_CP_MortgageDeal[] => state.entities,
);

export const selectedBetterDealIndex = createSelector(
  selectBetterDealState,
  (state: BetterDealsState): number => state.selectedBetterDealIndex,
);

export const selectedBetterDeal = createSelector(selectBetterDealState, (state: BetterDealsState): HTTP_CP_MortgageDeal => {
  return state.selectedBetterDeal;
});

export const selectDealsByMortgageId = (mortgageId: string) =>
  createSelector(selectBetterDealList, selectedBetterDealIndex, (deals, selectedBetterDealIndex): Mortgage_Deals => {
    const selectedDeals: HTTP_CP_MortgageDeal[] = deals[mortgageId];
    if (selectedDeals) {
      return {
        deals: selectedDeals,
        selectedBetterDealIndex: selectedBetterDealIndex ?? 0,
      };
    } else {
      return undefined;
    }
  });

export const selectIsLoadingBetterDeals = createSelector(selectBetterDealState, (state: BetterDealsState): boolean => state.loading);

export const selectBetterDealNotFound = createSelector(
  selectBetterDealState,
  (state: BetterDealsState): boolean => state.betterDealNotFound,
);
